import { Component, DestroyRef, OnInit } from '@angular/core';
import { UtilService } from '../../../services/util.service';
import { ActivatedRoute } from '@angular/router';
import { API, PlayerHardwareDTO } from '../../../services/api/api';
import { NavigationService } from '@ngx-seatback/utils';
import { ErrorService } from '../../../services/error.service';
import { PermissionService } from '../../../services/permission.service';
import { finalize, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'sb-page-player-hardware-details',
  templateUrl: './player-hardware-details.component.html',
  styleUrls: ['./player-hardware-details.component.scss'],
  standalone: false,
})
export class PlayerHardwareDetailsComponent implements OnInit {
  private playerHardwareID: number;
  public playerHardware: PlayerHardwareDTO;
  private loading: boolean;

  constructor(
    private api: API,
    public util: UtilService,
    public errorHandler: ErrorService,
    private navService: NavigationService,
    private activatedRoute: ActivatedRoute,
    public permissionService: PermissionService,
    private destroyRef: DestroyRef
  ) {
    this.loading = true;
    this.playerHardware = null;
    this.playerHardwareID = null;
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.playerHardwareID = +params.playerHardwareID;
      this.refresh();
    });
  }

  refresh() {
    this.loading = true;
    this.api
      .ca_md_PlayerHardware_retrieveById(this.playerHardwareID)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (p: PlayerHardwareDTO) => {
          this.playerHardware = p;
        },
        error: error => {
          if (error.status && (+error.status === 403 || +error.status === 404)) {
            this.navService.navigateToPoint(this.util.RoutingID.playerHardware);
          } else {
            this.errorHandler.errorHandler(error);
          }
        },
      });
  }
}
